import { render, staticRenderFns } from "./MultiWhatsappChannels.vue?vue&type=template&id=2827a89e&scoped=true"
import script from "./MultiWhatsappChannels.vue?vue&type=script&lang=js"
export * from "./MultiWhatsappChannels.vue?vue&type=script&lang=js"
import style0 from "./MultiWhatsappChannels.vue?vue&type=style&index=0&id=2827a89e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2827a89e",
  null
  
)

export default component.exports